export default __webpack_public_path__ + "static/screenshot5-c8d327508371abb43c7ec97b8b4cff8c.jpg";